import { render } from "./DepositeModal.vue?vue&type=template&id=17bdcc33&scoped=true"
import script from "./DepositeModal.vue?vue&type=script&lang=js"
export * from "./DepositeModal.vue?vue&type=script&lang=js"

import "./DepositeModal.vue?vue&type=style&index=0&id=17bdcc33&lang=scss&scoped=true"

import exportComponent from "G:\\Programming\\VueProjects\\radinrealp2p\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17bdcc33"]])

export default __exports__